<template>
  <label class="bx-switch">
    <input type="checkbox"
           :checked="modelValue"
           @change="$emit('update:model-value', $event.target.checked)">
    <span />
  </label>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:model-value']
}
</script>
